import { AppState } from '../../../redux/reducers';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';
import { SettlementDetail } from '../../../models/Entities/SettlementDetails/SettlementDetail';
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';
import * as SettlementDetailsStore from '../../../redux/middleware/SettlementDetailsMiddleware';
import { getProtocolTitleLookup } from '../SettlementProtocolBreakdown/SettlementProtocolBreakdown.Functions';
import { ProtocolTitleLookup } from '../SettlementProtocolBreakdown/SettlementProtocolBreakdown.Logic';

interface IProps {
    SettlementId: number;
}

interface ConnectedProps {
    Settlement: Settlement | undefined;
    /** `undefined` mientras no se pidieron (o se perdieron con un refresco de la cabecera). */
    details: SettlementDetail[] | undefined;
    isGettingDetails: boolean;
    failOnGettingDetails: boolean;
    /** Título del protocolo desde el store (los carga el desglose por protocolo). */
    ProtocolTitleOf: ProtocolTitleLookup;
}

interface DispatchProps {
    GetSettlementById: typeof SettlementStore.actionCreators.GetSettlementById;
    /** `GetSettlementById` no vuelve a pedir lo que ya está en el store: el polling usa el refresco. */
    RefreshSettlementById: typeof SettlementStore.actionCreators.RefreshSettlementById;
    GetAllSettlementDetails: typeof SettlementDetailsStore.actionCreators.GetAllSettlementDetails;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps): ConnectedProps => {
    const settlement: Settlement | undefined = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId);
    return {
        Settlement: settlement,
        details: settlement?.details,
        isGettingDetails: !!settlement?.isGettingDetails,
        failOnGettingDetails: !!settlement?.failOnGettingDetails,
        ProtocolTitleOf: getProtocolTitleLookup(state.MedicalProtocols?.list),
    };
};

export const mapDispatchToProps = {
    GetSettlementById: SettlementStore.actionCreators.GetSettlementById,
    RefreshSettlementById: SettlementStore.actionCreators.RefreshSettlementById,
    GetAllSettlementDetails: SettlementDetailsStore.actionCreators.GetAllSettlementDetails,
};
